// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__zlpOE","modal":"Modal_modal__CggK7","slide-down":"Modal_slide-down__ZYn3V"};